import React, {useEffect, useRef} from 'react';

export default function ActionItemDropdownPriorities({action_item, action}) 
{
    const tooltipRef_on_fire = useRef(null);
    const tooltipRef_hot     = useRef(null);
    const tooltipRef_normal  = useRef(null);
    const tooltipRef_low     = useRef(null);

    var tooltip_on_fire, tooltip_hot, tooltip_normal, tooltip_low;

    //The tooltip instances must match the return values below or you get a "trigger" error in the browser
    useEffect(() => {
        switch (action_item.Priority)
        {
            case "On-Fire":
                tooltip_hot     = new window.bootstrap.Tooltip(tooltipRef_hot.current, { container: 'body', trigger: 'hover' });
                tooltip_normal  = new window.bootstrap.Tooltip(tooltipRef_normal.current, { container: 'body', trigger: 'hover' });
                tooltip_low     = new window.bootstrap.Tooltip(tooltipRef_low.current, { container: 'body', trigger: 'hover' });
        
                return () => {
                    tooltip_hot.dispose();
                    tooltip_normal.dispose();
                    tooltip_low.dispose();
                };
            case "Hot":
                tooltip_on_fire = new window.bootstrap.Tooltip(tooltipRef_on_fire.current, { container: 'body', trigger: 'hover' });
                tooltip_normal  = new window.bootstrap.Tooltip(tooltipRef_normal.current, { container: 'body', trigger: 'hover' });
                tooltip_low     = new window.bootstrap.Tooltip(tooltipRef_low.current, { container: 'body', trigger: 'hover' });
        
                return () => {
                    tooltip_on_fire.dispose();
                    tooltip_normal.dispose();
                    tooltip_low.dispose();
                };
            case "Normal":
                tooltip_on_fire = new window.bootstrap.Tooltip(tooltipRef_on_fire.current, { container: 'body', trigger: 'hover' });
                tooltip_hot     = new window.bootstrap.Tooltip(tooltipRef_hot.current, { container: 'body', trigger: 'hover' });
                tooltip_low     = new window.bootstrap.Tooltip(tooltipRef_low.current, { container: 'body', trigger: 'hover' });
        
                return () => {
                    tooltip_on_fire.dispose();
                    tooltip_hot.dispose();
                    tooltip_low.dispose();
                };
            case "Low":
                tooltip_on_fire = new window.bootstrap.Tooltip(tooltipRef_on_fire.current, { container: 'body', trigger: 'hover' });
                tooltip_hot     = new window.bootstrap.Tooltip(tooltipRef_hot.current, { container: 'body', trigger: 'hover' });
                tooltip_normal  = new window.bootstrap.Tooltip(tooltipRef_normal.current, { container: 'body', trigger: 'hover' });
        
                return () => {
                    tooltip_on_fire.dispose();
                    tooltip_hot.dispose();
                    tooltip_normal.dispose();
                };   
        }   
    }, []);

    switch (action_item.Priority)
    {
        case "On-Fire": 
            return (
                <>
                    Change Priority:
                    <a href="#" ref={tooltipRef_hot}    data-bs-toggle="tooltip" data-bs-title="Hot"    data-bs-delay="750"><img class="list_item_icon-start" src="./images/hot-col.svg"     alt="Hot"    border="0" onClick={ () => action("upd_priority_hot") } /></a>
                    <a href="#" ref={tooltipRef_normal} data-bs-toggle="tooltip" data-bs-title="Normal" data-bs-delay="750"><img class="list_item_icon"       src="./images/normal2-col.svg" alt="Normal" border="0" onClick={ () => action("upd_priority_normal") } /></a>
                    <a href="#" ref={tooltipRef_low}    data-bs-toggle="tooltip" data-bs-title="Low"    data-bs-delay="750"><img class="list_item_icon-end"   src="./images/low2-col.svg"    alt="Low"    border="0" onClick={ () => action("upd_priority_low") } /></a>
                </>
            );
        case "Hot":
            return (
                <>
                    Change Priority:
                    <a href="#" ref={tooltipRef_on_fire} data-bs-toggle="tooltip" data-bs-title="On-Fire" data-bs-delay="750"><img class="list_item_icon-start" src="./images/on-fire-col.svg" alt="On-Fire" border="0" onClick={ () => action("upd_priority_on_fire") } /></a>
                    <a href="#" ref={tooltipRef_normal}  data-bs-toggle="tooltip" data-bs-title="Normal"  data-bs-delay="750"><img class="list_item_icon"       src="./images/normal2-col.svg" alt="Normal"  border="0" onClick={ () => action("upd_priority_normal") } /></a>
                    <a href="#" ref={tooltipRef_low}     data-bs-toggle="tooltip" data-bs-title="Low"     data-bs-delay="750"><img class="list_item_icon-end"   src="./images/low2-col.svg"    alt="Low"     border="0" onClick={ () => action("upd_priority_low") } /></a>
                </>
            );
        case "Normal":
            return (
                <>
                    Change Priority:
                    <a href="#" ref={tooltipRef_on_fire} data-bs-toggle="tooltip" data-bs-title="On-Fire" data-bs-delay="750"><img class="list_item_icon-start" src="./images/on-fire-col.svg" alt="On-Fire" border="0" onClick={ () => action("upd_priority_on_fire") } /></a>
                    <a href="#" ref={tooltipRef_hot}     data-bs-toggle="tooltip" data-bs-title="Hot"     data-bs-delay="750"><img class="list_item_icon"       src="./images/hot-col.svg"     alt="Hot"     border="0" onClick={ () => action("upd_priority_hot") } /></a>
                    <a href="#" ref={tooltipRef_low}     data-bs-toggle="tooltip" data-bs-title="Low"     data-bs-delay="750"><img class="list_item_icon-end"   src="./images/low2-col.svg"    alt="Low"     border="0" onClick={ () => action("upd_priority_low") } /></a>
                </>
            );
        case "Low":
            return (
                <>
                    Change Priority:
                    <a href="#" ref={tooltipRef_on_fire} data-bs-toggle="tooltip" data-bs-title="On-Fire" data-bs-delay="750"><img class="list_item_icon-start" src="./images/on-fire-col.svg" alt="On-Fire" border="0" onClick={ () => action("upd_priority_on_fire") } /></a>
                    <a href="#" ref={tooltipRef_hot}     data-bs-toggle="tooltip" data-bs-title="Hot"     data-bs-delay="750"><img class="list_item_icon"       src="./images/hot-col.svg"     alt="Hot"     border="0" onClick={ () => action("upd_priority_hot") } /></a>
                    <a href="#" ref={tooltipRef_normal}  data-bs-toggle="tooltip" data-bs-title="Normal"  data-bs-delay="750"><img class="list_item_icon-end"  src="./images/normal2-col.svg" alt="Normal"  border="0" onClick={ () => action("upd_priority_normal") } /></a>
                </>
            );
    }
}